import React from "react";
import s from "./Header.module.scss";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
type headerProp = {
  unauthorized: boolean;
};
function Header({ unauthorized }: headerProp) {
  const navigate = useNavigate();
  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>Promo codes</h1>
      <Tooltip  title={unauthorized && "Unauthorized"}>
        <button
          disabled={unauthorized}
          onClick={() => navigate("/dashboard/promo-code/create")}
        >
          Create code
        </button>
      </Tooltip>
    </div>
  );
}

export default Header;
